import React, { useState } from 'react'
import { Text, View } from 'styles/reactnative'
import AdminSettingSearch from './AdminSettingSearch'
import { COLORS } from 'app/constants'

const AdminSettingHeader = ({
	searchText,
	searchApi,
	CustomComp,
	title,
	style,
}: any) => {
	const [search, setSearch] = useState(searchText)
	const searchData = (value: string) => {
		setSearch(value)
		searchApi(value)
	}
	return (
		<View
			style={{
				width: '100%',
				flexDirection: 'row',
				justifyContent: 'space-between',
				minHeight: 40,
				background: COLORS.gray2,
				padding: 10,
				marginTop: 10,
				borderTopLeftRadius: 10,
				borderTopRightRadius: 10,
				...style,
			}}>
			<View style={{ flexDirection: 'row' }}>
				<Text
					style={{
						fontSize: 20,
						fontWeight: 'bold',
						color: COLORS.white,
					}}>
					{title}
				</Text>
			</View>
			<AdminSettingSearch search={search} searchData={searchData} />
			{CustomComp ? CustomComp : null}
		</View>
	)
}

export default AdminSettingHeader
